import { render, staticRenderFns } from "./TagsIcon.vue?vue&type=template&id=0be5c2bb&scoped=true"
import script from "./TagsIcon.vue?vue&type=script&lang=js"
export * from "./TagsIcon.vue?vue&type=script&lang=js"
import style0 from "./TagsIcon.vue?vue&type=style&index=0&id=0be5c2bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5c2bb",
  null
  
)

export default component.exports